import e from "react";
import { useTranslations as o, useKnockSlackClient as t } from "@knocklabs/react-core";
import c from "./icons/InfoIcon.mjs";
const i = () => {
  const {
    t: n
  } = o(), {
    connectionStatus: r
  } = t();
  return r === "disconnected" || r === "error" ? /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__error" }, /* @__PURE__ */ e.createElement("span", null, /* @__PURE__ */ e.createElement(c, null)), /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__error__text" }, n(r === "disconnected" ? "slackConnectionErrorOccurred" : "slackConnectionErrorExists"))) : /* @__PURE__ */ e.createElement("div", null);
};
export {
  i as default
};
//# sourceMappingURL=SlackConnectionError.mjs.map
